import React, { ReactElement, memo } from 'react'
import Grid from '@sport1/react-elements/Grid'

import SkeletonBar from '../SkeletonBar'
import SkeletonTeaserInfo from '../SkeletonTeaserInfo'

type SkeletonTextsProps = {
    marginTop?: number
    marginLeft?: number
}

const SkeletonTexts = ({ marginTop = 0, marginLeft = 0 }: SkeletonTextsProps): ReactElement => {
    return (
        <Grid marginTop={marginTop} marginLeft={marginLeft}>
            <SkeletonBar />
            <SkeletonBar marginTop={2} width="50%" />
            <Grid alignBottom>
                <SkeletonTeaserInfo />
            </Grid>
        </Grid>
    )
}

export default memo(SkeletonTexts)
